import React from 'react'
import DataField from "../../../utils/DataField"
import {titleCase, upperCase} from "../../../utils/utils"
import moment from "moment"
import { useTranslation } from "react-i18next";

function RNEOCR(props){

    const { t } = useTranslation()

    const { OCR } = props

    const formatDate = (date) => date ? moment(date).format('DD/MM/YYYY') : null

    return(
        <div style={{display:"flex", width:"70%", flexDirection: "column"}}>
            <DataField
                title={t("name")}
                label={titleCase(OCR.name, null)}
                size={"normalMediumSize"}
                titleNoWrap={true}
                margin="5px"
            />
            <DataField
                title={t("rne_number")}
                label={upperCase(OCR.rne_number, null)}
                size={"normalMediumSize"}
                titleNoWrap={true}
                margin="5px"
            />
            <DataField
                title={t("birthdate")}
                label={formatDate(OCR.birthdate)}
                size={"normalMediumSize"}
                titleNoWrap={true}
                margin="5px"
            />
            <DataField
                title={t("gender")}
                label={titleCase(OCR.gender, null)}
                size={"normalMediumSize"}
                titleNoWrap={true}
                margin="5px"
            />
            <DataField
                title={t("nationality")}
                label={titleCase(OCR.nationality, null)}
                size={"normalMediumSize"}
                titleNoWrap={true}
                margin="5px"
            />
            <DataField
                title={t("father_name")}
                label={titleCase(OCR.father_name, null)}
                size={"normalMediumSize"}
                titleNoWrap={true}
                margin="5px"
            />
            <DataField
                title={t("mother_name")}
                label={titleCase(OCR.mother_name, null)}
                size={"normalMediumSize"}
                titleNoWrap={true}
                margin="5px"
            />
            <DataField
                title={t("classification")}
                label={upperCase(OCR.classification, null)}
                size={"normalMediumSize"}
                titleNoWrap={true}
                margin="5px"
            />
            <DataField
                title={t("issuance_date")}
                label={formatDate(OCR.issuance_date)}
                size={"normalMediumSize"}
                titleNoWrap={true}
                margin="5px"
            />
            <DataField
                title={t("expiration_date")}
                label={formatDate(OCR.expiration_date)}
                size={"normalMediumSize"}
                titleNoWrap={true}
                margin="5px"
            />
        </div>
    )
}

export default RNEOCR
